// extracted by mini-css-extract-plugin
export default {"description":"UserBlocked_description__eTzNa","formLabel":"UserBlocked_formLabel__MAj+F","icon":"UserBlocked_icon__gGAoN","link":"UserBlocked_link__5Ewhq"};